import { useQuery } from "@tanstack/react-query";
import { ComunicacionAjax } from "../../../../ts/api/comunicacion";
import { Loading, QueryError } from "../../../../components/Loading/Loading";

export function FiltroCiclos(props: { readonly filtroCiclo: string | null; readonly setFiltroCiclo: (value: string | null) => void; }) {
	function cicloPrioridadToString(id: number): string {
		switch (id) {
			case 1: return "Tiempo Real";
			case 2: return "Alta";
			case 3: return "Normal";
			case 4: return "Menor";
			case 5: return "Baja";
		}
		return "Desconocido";
	}

	const { data, error, isPending } = UseCiclosLanzados();

	if (error) return <QueryError error={error} fallback="Error al cargar los ciclos lanzados" />;
	if (isPending) return <Loading />;

	return (
		<div style={{ padding: 30, display: "flex" }}>
			<label style={{ fontSize: 17, marginTop: 6, marginRight: 5 }}>Ciclos: </label>
			<select className="form-control limpiar" value={props.filtroCiclo ?? ""} onChange={e => props.setFiltroCiclo(e.target.value || null)}>
				<option value="" selected>Sin Filtrar</option>
				{data.map((linea) => (
					<option key={linea.id} value={linea.id}>{linea.id} - Prioridad {cicloPrioridadToString(linea.prioridad)}</option>
				))}
			</select>
		</div>
	);
}
function UseCiclosLanzados() {
	return useQuery<CicloLanzado[]>({
		queryKey: ["getCiclosLanzados"],
		queryFn: () => ComunicacionAjax.sendAjaxRequest<CicloLanzado[]>("GET", "/getCiclosLanzados"),
	});
}
interface CicloLanzado {
	id: number,
	prioridad: number;
}
